import { findParentDomRefOfType } from '@atlaskit/editor-prosemirror/utils';
import { akEditorFloatingPanelZIndex } from '@atlaskit/editor-shared-styles';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { insertSuggestion, removeSuggestion } from '../pm-plugins/ai-spelling-grammar/commands';
import { getPluginState as getSpellingAndGrammarPluginState } from '../pm-plugins/ai-spelling-grammar/plugin-factory';
import { messages } from './messages';
import { separator } from './seperator';
export const getFloatingToolbarConfig = () => (state, intl) => {
  if (getBooleanFF('platform.editor.ai-real-time-spelling-and-grammar_mtaik')) {
    const {
      isSpellingAndGrammarEnabled,
      allDiffObjects
    } = getSpellingAndGrammarPluginState(state) || {};
    if (isSpellingAndGrammarEnabled && allDiffObjects && state.selection.from === state.selection.to) {
      const selectedDiff = allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.find(({
        from,
        to
      }) => state.selection.from <= to && state.selection.from >= from);
      if (!selectedDiff) {
        return;
      }
      const nodeType = [state.schema.nodes.paragraph, state.schema.nodes.text, state.schema.nodes.heading, state.schema.nodes.taskItem, state.schema.nodes.decisionItem];
      const {
        id,
        from,
        to,
        text,
        originalText
      } = selectedDiff;

      /**
       * TODO: Currently the decoration can be split by other decorations and marks
       * e.g. editor-plugin-selection-marker decoration widget, or any marks e.g. bold / italics
       */
      const getDomRef = editorView => {
        let element;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const parent = findParentDomRefOfType(nodeType, domAtPos)(state.selection);
        if (parent) {
          element = parent.querySelector(`#ai-sg-${id}`) || undefined;
        }
        return element;
      };
      return {
        title: 'Spelling & Grammar controls',
        getDomRef,
        nodeType,
        zIndex: akEditorFloatingPanelZIndex + 1,
        // Place the context menu slightly above the others
        items: [{
          id: 'editor.ai.sg-suggestion',
          type: 'button',
          showTitle: true,
          testId: 'ak-editor-ai-suggestion-toolbar-suggestion-button',
          onClick: insertSuggestion(from, to),
          title: text,
          focusEditoronEnter: true
        }, separator(), {
          id: 'editor.ai.sg-dismiss',
          type: 'button',
          testId: 'ak-editor-ai-suggestion-toolbar-dismiss-button',
          icon: EditorCloseIcon,
          onClick: removeSuggestion(from, to, originalText),
          title: intl.formatMessage(messages.dismissSuggestion),
          focusEditoronEnter: true
        }],
        scrollable: false,
        align: 'left'
      };
    }
  }
  return;
};